var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"history-list-wrapper"},[_c('a-row',_vm._l((_vm.data),function(history){return _c('a-col',{key:history.id,staticClass:"history-item-wrapper",attrs:{"span":24},on:{"click":function($event){return _vm.$emit('onHistoryActive', history)}}},[_c('HistoryItem',{attrs:{"data":history,"activeId":_vm.activeId}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }